type DownloadType = 'link' | 'base64'

export function generateDownloadFile(
  source: string,
  fileName: string,
  type: DownloadType = 'link'
) {
  let linkSource

  if (type === 'base64') {
    linkSource = `data:application/pdf;base64,${source}`
  } else {
    linkSource = source
  }

  const downloadLink = document.createElement('a')
  downloadLink.href = linkSource
  downloadLink.download = fileName + '.pdf'
  downloadLink.target = '__blank'
  downloadLink.click()
}
